import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "rt-portal-notification_fill",
  "use": "rt-portal-notification_fill-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 1024 1024\" id=\"rt-portal-notification_fill\">\r\n<path d=\"M512,896c-18.5,0-33.8-14-35.8-32h71.5C545.8,882,530.5,896,512,896z\" />\r\n<path d=\"M920,784h-56V463.9c0-178.7-135-327.4-308-349.2V108c0-24.2-19.8-44-44-44s-44,19.8-44,44v6.7\r\n\tc-173,21.8-308,170.5-308,349.2V784h-56c-22,0-40,18-40,40s18,40,40,40h308.1c2.1,53.3,46.1,96,99.9,96s97.8-42.7,99.9-96H920\r\n\tc22,0,40-18,40-40S942,784,920,784z M724,660c0,24.3-19.7,44-44,44s-44-19.7-44-44V492c0-24.3,19.7-44,44-44s44,19.7,44,44V660z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./~/rt-svg-sprite-loader/lib/loader.js?{"symbolId":"rt-portal-[name]"}!./src/assets/icons/svgs/notification_fill.svg
// module id = 1257
// module chunks = 101